import { UseFormRegister, FieldValues, DeepMap, FieldError } from 'react-hook-form';
import EditButton from '../EditButton';
import generateErrorMarkup from '../generateErrorMarkup';

type Props = {
  name: string;
  label: string;
  disclaimer?: React.ReactElement;
  // TODO: do I want to add a validation pattern to tel? Apparently it doesn't have one by default
  type?: 'text' | 'email' | 'tel' | 'hidden';
  // Optional default value (will revert to formData[name] if none)
  defaultValue?: string;
  showEditBtn: boolean;
  editable: boolean;
  validationObj?: any; // TODO: add types
  hidden?: boolean;
  honey?: boolean;

  register: UseFormRegister<FieldValues>;
  errors: DeepMap<FieldValues, FieldError>;
  formData: any;
  returnToStep?: (name: string) => void;
}

/**
 * A TextInput component
 * @param props
 */
let TextInput = (props: Props) => {


  // TODO: react-hook-form probably has a better way of passing refs around
  // but this seems to work for now...
  const { register, errors } = props;

  const clickEditBtn = (e: React.MouseEvent) => {
    // Only has one if added for reviewMode
    if (props.returnToStep) props.returnToStep(props.name);
  };

  const defaultValue = props.defaultValue ?? props.formData[props.name] ?? '';

  // TODO: is this fine or do i need to save state somehow?
  if (props.hidden) return null;

  const validationObj = {...props.validationObj}
  validationObj.shouldUnregister = true;
  if (props.type === 'tel') {
    // Set custom error message for tel inputs
    if (!validationObj.validate) validationObj.validate = {};
    validationObj.validate.phoneRegex = (value: string) => {
      // https://stackoverflow.com/a/16699507/5208930
      const PHONE_REGEX = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
      return PHONE_REGEX.test(value) || 'Invalid phone number';
    }
  }
  if (props.honey) {
    // Add honey pot validation (ensure it's empty)
    if (!validationObj.validate) validationObj.validate = {};
    validationObj.validate.empty = (value: string) => {
      // TODO: for some reason, if you modify the field value in the dev tools,
      // it doesn't change from '' here,
      // so I need to get the element and read manually.
      let input = document.querySelector(`input[name="${props.name}"]`) as HTMLInputElement;
      if (!input) return 'Error';
      return (input.value === '') || 'Error';
    };
  }

  const required = validationObj?.required;

  const input = (
    <input {...register(props.name, validationObj)}
      type={props.type || 'text'}
      data-def={defaultValue}
      defaultValue={defaultValue}
      className={errors[props.name] ? 'parsley-error' : undefined}
      aria-describedby={errors[props.name] ? `${props.name}-errors` : undefined}
      disabled={!props.editable}
      placeholder={required ? `${props.label}*` : props.label}
    />
  );

  return (
    <>
      {props.type === 'hidden' ?
      input // Just display the raw input for hidden fields
      :
      <div className={`TextInput ${props.honey ? 'honey-field' : ''}`}>
        <label>
          <span className="sr-only">
            {`${props.label}:`}{required? '*' : null}
          </span>
          <div className='TextInput__Wrapper'>
            {input}
            { props.showEditBtn ? <EditButton onClick={clickEditBtn} /> : null }
          </div>
          {props.disclaimer ?
            <div className="Field__Disclaimer">
              {props.disclaimer}
            </div>
          : null
          }
        </label>
        { generateErrorMarkup(errors, props.name) }
      </div>
    }
    </>
  );
};

export default TextInput;
